"use client";

import Link from "next/link";
import NavigationButton from "./NavigationButton";
import { FaHeadphones } from "react-icons/fa";
import { usePathname } from "next/navigation";
import { Translations } from "@/Languages";
import { ExternalLink, Menu, Settings } from "lucide-react";
import { useState } from "react";

const Links = () => (
  <>
    <Link href="#ref">Referenzen</Link>
    <Link href="#why">Warum</Link>
    <Link href="#app">Funktionsweise</Link>
    <Link href="#impact">Impact</Link>
    <Link href="#pricing">Lizenzpaket</Link>
    <Link
      href="https://dashboard.tralster.com/"
      className="flex items-center justify-end gap-1"
    >
      Login <ExternalLink size={16} />
    </Link>
  </>
);

export default function Header({ LANG }: Readonly<{ LANG: Translations }>) {
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const [open, setOpen] = useState(false);

  return (
    <header className="dark:bg-item-dark sticky top-0 z-50 bg-white text-black shadow-md dark:text-white">
      <div className="container mx-auto flex items-center justify-between gap-4 p-2">
        <NavigationButton />

        <Link
          href="/"
          className="flex grow items-center gap-2"
          aria-hidden={true}
        >
          <div className="bg-primary rounded p-1 text-white">
            <FaHeadphones />
          </div>
          <div className="font-indie-flower text-xl">TRALSTER</div>
        </Link>

        {isHomePage && (
          <>
            <div className="hidden grow gap-6 lg:flex">
              <Links />
            </div>

            <Link
              href="/meeting"
              aria-hidden={true}
              className="bg-primary flex items-center gap-2 rounded p-1 px-2 text-white"
            >
              {LANG.scheduleMeeting}
            </Link>

            <button
              className="relative block p-0.5 drop-shadow-xl lg:hidden"
              onClick={() => setOpen((prev) => !prev)}
            >
              <Menu />
              <div
                className={`absolute top-[150%] right-0 overflow-clip transition-all ${open ? "h-64" : "h-0"}`}
              >
                <div className="dark:bg-item-dark flex flex-col gap-4 rounded-xl bg-white p-4 text-right text-base">
                  <Links />
                </div>
              </div>
            </button>
          </>
        )}

        {!isHomePage && (
          <>
            <Link
              href="/"
              aria-hidden={true}
              className="bg-primary flex items-center gap-2 rounded p-1 px-2 text-white"
            >
              {LANG.learnMore}
            </Link>

            <Link href="/settings" aria-label={LANG.settings}>
              <Settings />
            </Link>
          </>
        )}
      </div>
    </header>
  );
}
